import { Link } from "react-router-dom";
import NetworkGraph from "../../components/NetworkGraph";
import Reveal from "../../components/Reveal";
import {
  IconGear, IconMonitor, IconHeadset, IconClipboard, IconX, IconCheck,
} from "../../components/Icons";

const SERVICES = [
  {
    accent: "#0066FF",
    bg: "rgba(0,102,255,.12)",
    Icon: IconGear,
    tag: "MSP Core",
    title: "Gestão de TI",
    desc: "Seu departamento de TI terceirizado. Monitoramento proativo, gestão de infraestrutura, patches e atualizações, e suporte ilimitado — tudo em um único contrato mensal.",
    href: "/servicos/gestao-ti",
  },
  {
    accent: "#4D94FF",
    bg: "rgba(77,148,255,.12)",
    Icon: IconMonitor,
    tag: "RMM",
    title: "Gestão de Endpoints",
    desc: "Monitoramento e gerenciamento remoto de todos os dispositivos da sua empresa. Visibilidade total, alertas em tempo real, automação de tarefas e inventário de hardware e software.",
    href: "/servicos/rmm",
  },
  {
    accent: "#0EA5E9",
    bg: "rgba(14,165,233,.12)",
    Icon: IconHeadset,
    tag: "Helpdesk",
    title: "Suporte Técnico",
    desc: "Abertura de chamados, atendimento remoto imediato e visitas presenciais em São Paulo. Equipe técnica disponível para resolver qualquer problema e não parar sua operação.",
    href: "/servicos/suporte",
  },
  {
    accent: "#8B90A0",
    bg: "rgba(139,144,160,.12)",
    Icon: IconClipboard,
    tag: "Consultoria",
    title: "Consultoria & Projetos",
    desc: "Levantamento de infraestrutura, planejamento estratégico de TI, migração para nuvem, implantação de sistemas e projetos customizados para a realidade da sua empresa.",
    href: "/servicos/consultoria",
  },
];

export default function Servicos() {
  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <span>Serviços</span>
          </div>
          <div className="tag animate-up animate-up--d1">Serviços Gerenciados · MSP</div>
          <h1
            className="section-title animate-up animate-up--d2"
            style={{ fontSize: "clamp(36px,5vw,56px)", maxWidth: "700px" }}
          >
            O que a sepolTECH
            <br />
            <span className="text-blue">faz por você</span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "580px",
              lineHeight: "1.7",
              marginTop: "16px",
            }}
          >
            Contratos de gestão contínua onde nossa equipe cuida da sua
            infraestrutura de TI. Você foca no negócio — nós cuidamos da
            tecnologia.
          </p>
        </div>
      </section>

      {/* ═══════════════ O QUE É MSP ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal
            style={{
              maxWidth: "760px",
              margin: "0 auto",
              textAlign: "center",
              marginBottom: "64px",
            }}
          >
            <div className="tag">O que é um MSP?</div>
            <h2 className="section-title">
              Seu departamento de TI,
              <br />
              <span className="text-blue">terceirizado e proativo</span>
            </h2>
            <p style={{ fontSize: "17px", color: "var(--text-secondary)", lineHeight: "1.7" }}>
              Um Managed Service Provider (MSP) assume a responsabilidade
              pela gestão de toda a sua infraestrutura de TI por um valor
              mensal fixo. Diferente do suporte reativo — que age só quando
              quebra —, o MSP monitora, previne e resolve antes que
              problemas afetem sua operação.
            </p>
          </Reveal>
          <div
            className="grid-2"
            style={{ gap: "20px", maxWidth: "900px", margin: "0 auto 48px" }}
          >
            <Reveal
              delay={0}
              style={{
                background: "rgba(239,68,68,.05)",
                border: "1px solid rgba(239,68,68,.2)",
                borderRadius: "var(--radius-lg)",
                padding: "32px",
              }}
            >
              <h3
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  color: "var(--error)",
                  fontSize: "16px",
                  fontWeight: 700,
                  marginBottom: "16px",
                }}
              >
                <span
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    background: "rgba(239,68,68,.15)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <IconX style={{ width: "13px", height: "13px" }} />
                </span>
                Suporte tradicional (reativo)
              </h3>
              <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                  Você liga quando o problema já aconteceu
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                  Custo imprevisível por chamado
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                  Sem monitoramento contínuo
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                  Downtime afeta a operação
                </li>
              </ul>
            </Reveal>
            <Reveal
              delay={0.1}
              style={{
                background: "rgba(34,197,94,.05)",
                border: "1px solid rgba(34,197,94,.2)",
                borderRadius: "var(--radius-lg)",
                padding: "32px",
              }}
            >
              <h3
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  color: "var(--success)",
                  fontSize: "16px",
                  fontWeight: 700,
                  marginBottom: "16px",
                }}
              >
                <span
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    background: "rgba(34,197,94,.15)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <IconCheck style={{ width: "13px", height: "13px" }} />
                </span>
                sepolTECH MSP (proativo)
              </h3>
              <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                  Monitoramento 24/7 e alertas automáticos
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                  Mensalidade fixa, sem surpresas
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                  Prevenção antes do problema acontecer
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                  Continuidade operacional garantida
                </li>
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ SERVIÇOS ═══════════════ */}
      <section className="section section--alt">
        <div className="container">
          <Reveal className="text-center" style={{ marginBottom: "56px" }}>
            <div className="tag">Nossos serviços</div>
            <h2 className="section-title">
              Escolha o que sua
              <br />
              <span className="text-blue">empresa precisa</span>
            </h2>
          </Reveal>

          <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            {SERVICES.map((service, i) => (
              <Reveal
                as={Link}
                to={service.href}
                className="card card-list-item card-list-item--sm"
                style={{ "--accent": service.accent }}
                delay={i * 0.06}
                key={service.title}
              >
                <div
                  className="card__icon"
                  style={{
                    width: "72px",
                    height: "72px",
                    background: service.bg,
                    color: service.accent,
                    marginBottom: 0,
                  }}
                >
                  <service.Icon style={{ width: "30px", height: "30px" }} />
                </div>
                <div>
                  <div
                    className="card__tag"
                    style={{ color: service.accent, marginBottom: "8px" }}
                  >
                    {service.tag}
                  </div>
                  <h3
                    style={{
                      fontFamily: "var(--font-display)",
                      fontSize: "22px",
                      fontWeight: 700,
                      marginBottom: "8px",
                      color: "var(--text-primary)",
                    }}
                  >
                    {service.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "15px",
                      color: "var(--text-secondary)",
                      lineHeight: "1.6",
                      maxWidth: "600px",
                    }}
                  >
                    {service.desc}
                  </p>
                </div>
                <span
                  className="card-list-arrow"
                  style={{
                    color: service.accent,
                    fontWeight: 700,
                    fontSize: "20px",
                    flexShrink: 0,
                  }}
                >
                  →
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="cta-banner">
            <h2 className="cta-banner__title">Pronto para uma TI gerenciada?</h2>
            <p className="cta-banner__sub">
              Fale com a equipe sepolTECH e descubra o plano certo para sua
              empresa.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Solicitar proposta →
              </Link>
              <Link to="/faq" className="btn btn-outline">
                Dúvidas frequentes
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
